import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { Subscription } from 'rxjs';
import * as _ from "underscore";
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import moment from 'moment';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import cjson from 'compressed-json';

interface IWinningLosingTalent {
  company: string;
  winningTalent: number;
  losingTalent: number;
  totalTalent?: number;
  totalTalentMovement?: number;
  type?: string;
  companylogo?: string;
  website?: string;
}

interface IHireDepartureTalent {
  company: string;
  date: string;
  hireTalent: number;
  departureTalent: number;
  totalTalent?: number;
  order: number;
  label: string;
}

@Component({
    selector: 'app-talentmovement-tab',
    templateUrl: './talentmovement-tab.component.html',
    styleUrls: ['./talentmovement-tab.component.scss'],
    standalone: false
})
export class TalentmovementTabComponent implements OnInit {

  private viewSlice = 0;
  winningLosingTalent: IWinningLosingTalent[] = [];
  winningLosingTalentDisplayedColumns = ['company', 'winningTalent', 'losingTalent'];
  winningLosingTalentDataSource: any //= new MatTableDataSource<IWinningLosingTalent>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  hireDepartureTalent: IHireDepartureTalent[] = [];
  hireDepartureTalentDataSource: any = {};

  slicedWinningLosingTalent: IWinningLosingTalent[] = [];
  alternatecompanyNames: any
  aggregationcount: number = 250;

  /** start index in page */
  start: number = 0;
  /**End index in page */
  end: number = 5;
  /**Number of items on each of page */
  pageSize:number = 5;
  /**Current page number */
  currentPage: number = 1;
  /**Total items */
  totalCount = 0;
  currentCompanyName: any;

  /**
   * Get the company name
   */
  get company(): string {
    return this.companyDetails ? this.companyDetails.name : '';
  }
  subscriptions: Array<Subscription> = [];
  talentmovementAI: any
  totalresultcount: any;
  companyinsightsFilter: any = {};
  primaryCompanyInformation:any = {};
  winningCompanyTrends: any[] = [];
  loosingCompanyTrends: any[] = [];

  constructor(private personSearchService: PersonSearchService, private companyinsightsservice: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService) { }
  companyDetails: any;
  talentmovementsubscription: Subscription;
  insightsExportSubscription: Subscription = null;

  dataAvailable = {
    hiresAndDepartures : false,
    winningLosingTalent: false
  }
  /**
* Mapping of key and text value of headers
* In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
*/
  tableHeaderObj = {
    "company": "Company",
    "winning": "Winning Talent",
    "losing": "Losing Talent",
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  talentmovementGraphData: any
  filterData:any;

  ngOnInit(): void {
    // this.talentmovementsubscription = this.personSearchService.companyDetail.subscribe((companyDetails) => {
    //   this.companyDetails = companyDetails
    //   this.alternatecompanyNames = this.companyDetails.alternative_names && this.companyDetails.alternative_names.length > 0 ? this.companyDetails.alternative_names.concat([this.companyDetails.name]): [this.companyDetails.name];


    //   this.getcompanywinninglosingtalent()

    //  // this.getHireDepartureTalent();
    //   //this.prepareHireDepartureTalentChartData();


    // });
    this.start = 0;
    this.end = 5;
    this.currentPage = 1;
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
            this.filterData = this.filterDataHandlerService.fetchFilterData;

      this.fetchPageData()});
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsservice.insightsExportRequestEvent.subscribe(async (requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        await this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsservice.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.setLoaders();
    this.getcompanywinninglosingtalent();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  /**
   * Get the hire and departure talent
   * @private
   */
  private getHireDepartureTalent(): void {
    const hireDepartureTalentMovement: Record<string, IHireDepartureTalent> = {};
    if (!this.companyDetails) {
      return;
    }
    if (this.companyDetails.gross_departures_by_month) {
      const movementCompanies: [string, number][] = Object.entries(this.companyDetails.gross_departures_by_month);
      movementCompanies.forEach(([dateRaw, count]) => {
        const date = dateRaw + '-01';
        if (hireDepartureTalentMovement[date]) {
          hireDepartureTalentMovement[date].departureTalent = count;
          hireDepartureTalentMovement[date].totalTalent = hireDepartureTalentMovement[date].hireTalent + count;
        } else {
          hireDepartureTalentMovement[date] = {
            company: this.cleanCompanyName(this.company),
            departureTalent: count,
            hireTalent: 0,
            totalTalent: count,
            date,
            label: Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(new Date(date)),
            order: parseInt(date.replace(/-/g, ''), 10)
          };
        }
      });
    }
    if (this.companyDetails.gross_additions_by_month) {
      const movementCompanies: [string, number][] = Object.entries(this.companyDetails.gross_additions_by_month);
      movementCompanies.forEach(([dateRaw, count]) => {
        const date = dateRaw + '-01';
        if (hireDepartureTalentMovement[date]) {
          hireDepartureTalentMovement[date].hireTalent = count;
          hireDepartureTalentMovement[date].totalTalent = hireDepartureTalentMovement[date].departureTalent + count;
        } else {
          hireDepartureTalentMovement[date] = {
            company: this.cleanCompanyName(this.company),
            hireTalent: count,
            departureTalent: 0,
            totalTalent: count,
            date,
            label: Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(new Date(date)),
            order: parseInt(date.replace(/-/g, ''), 10)
          };
        }
      });
    }
    this.hireDepartureTalent = Object.values(hireDepartureTalentMovement).sort((a, b) => a.order - b.order).slice(-12);
  }



  /**
   * Sort the array
   */
  manualSort() {
    this.reSortArray(this.sort);
  }

  /**
   * Re-sort the array
   * @param {MatSort} sort
   */
  private reSortArray(sort: MatSort) {
    if(sort.active == 'losingTalent') {
      let loosingtowinningtalent = this.winningLosingTalent.filter(x=>x.type == 'loosingtowinning')
      let data = loosingtowinningtalent;
      if (!sort.active || sort.direction === '') {
        this.winningLosingTalentDataSource = new MatTableDataSource(loosingtowinningtalent);
        this.totalCount = loosingtowinningtalent.length;
        const data = loosingtowinningtalent.slice(this.start, this.end);

        this.winningLosingTalentDataSource.data = data;
        return;
      }

      loosingtowinningtalent = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'winningTalent': return this.compare(a.winningTalent, b.winningTalent, isAsc);
          case 'losingTalent': return this.compare(a.losingTalent, b.losingTalent, isAsc);
          default: return 0;
        }

      });
      this.winningLosingTalentDataSource = new MatTableDataSource(loosingtowinningtalent);
      this.totalCount = loosingtowinningtalent.length;
      this.winningLosingTalentDataSource.data = loosingtowinningtalent.slice(this.start, this.end);
    } else {
      let winningtolosingtalents = this.winningLosingTalent.filter(x=>x.type == 'winningtoloosing')
      if (!sort.active || sort.direction === '') {
        this.winningLosingTalentDataSource = new MatTableDataSource(winningtolosingtalents);
        this.totalCount = winningtolosingtalents.length;
        const data = winningtolosingtalents.slice(this.start, this.end);
        this.winningLosingTalentDataSource.data = data;
        return;
      }

      winningtolosingtalents = winningtolosingtalents.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'winningTalent': return this.compare(a.winningTalent, b.winningTalent, isAsc);
          case 'losingTalent': return this.compare(a.losingTalent, b.losingTalent, isAsc);
          default: return 0;
        }
      });
      this.winningLosingTalentDataSource = new MatTableDataSource(winningtolosingtalents);
      this.totalCount = winningtolosingtalents.length;
      const data = winningtolosingtalents.slice(this.start, this.end);

      this.winningLosingTalentDataSource.data = data;
    }


    //this.refreshSlice();
  }

  /**
   * Compare the two numbers
   * @private
   */
  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * Check if there is a next slice
   * @return {boolean}
   */
  get hasNextSlice(): boolean {
    return this.viewSlice < this.winningLosingTalent.length;
  }

  /**
   * View the next slice of the winning and losing talent
   */
  viewNextSlice(): void {
    if (this.viewSlice >= this.winningLosingTalent.length) {
      this.viewSlice = 0;
    }
    this.viewSlice += 5;
    this.slicedWinningLosingTalent = this.winningLosingTalent.slice(0, this.viewSlice);
    this.winningLosingTalentDataSource.data = this.slicedWinningLosingTalent;
  }

  /**
   * Check if there is a previous slice
   */
  refreshSlice(): void {
    this.viewSlice = Math.max(0, this.viewSlice - 5);
    this.viewNextSlice();
  }

  /**
   * Clean the company name
   * @param {string} companyName
   * @return {string}
   * @private
   */
  private cleanCompanyName(companyName: string): string {
    // replace - with space
    return companyName.replace(/-/g, ' ');
  }

  private getcompanywinninglosingtalent(): Promise<any> {
    const talentMovement: Record<string, IWinningLosingTalent> = {};
    const hireDepartureTalentMovement: Record<string, IHireDepartureTalent> = {};
    const loosingMovement: Record<string, IWinningLosingTalent> = {};

    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    requestObject.companies = this.alternatecompanyNames;
    requestObject.resultsize = this.aggregationcount;
    requestObject.startindex = this.start;
    requestObject.aggregatescount = this.aggregationcount;
    requestObject.companyids = [this.companyDetails.id];

    return new Promise((resolve) => {
      this.companyinsightsservice.getcompanywinningTalentFrom(requestObject).subscribe((res: any) => {
        this.totalresultcount = res.totalresultscount
        const winningtalents = res.aggregations.winningtalentfromcompany;
        this.winningCompanyTrends = res.aggregations.winningtrend
        this.companyinsightsservice.getcompanylosingtalentto(requestObject).subscribe((response: any) => {
          const losingtalents = response.aggregations.losingtalenttocompany;

          this.loosingCompanyTrends = response.aggregations.losingtrend;
          if(losingtalents.length == 0 && this.loosingCompanyTrends.length == 0) {
            this.dataAvailable.hiresAndDepartures = true;
            this.dataAvailable.winningLosingTalent = true;
          }

          res.aggregations.winningtalentfromcompany.forEach((data) => {
            const companyname = data.key
            if (talentMovement[companyname]) {
              talentMovement[companyname].winningTalent = data.doc_count;
            } else {
              talentMovement[companyname] = { company: this.cleanCompanyName(companyname), losingTalent: 0, winningTalent: data.doc_count, type: 'winningtoloosing' };
            }
            const companykey = losingtalents.filter(x => x.key == data.key)
            if (companykey.length > 0) {
              talentMovement[companyname].losingTalent = companykey[0].doc_count
            }
          })

          losingtalents.forEach((data) => {
            const companyname = data.key
            if (loosingMovement[companyname]) {
              loosingMovement[companyname].losingTalent = data.doc_count;
            } else {
              loosingMovement[companyname] = { company: this.cleanCompanyName(companyname), losingTalent: data.doc_count, winningTalent: 0, type: 'loosingtowinning' };
            }
            const companykey = winningtalents.filter(x => x.key == data.key)
            if (companykey.length > 0) {
              loosingMovement[companyname].winningTalent = companykey[0].doc_count
            }
          })
          let values = Object.values(talentMovement).concat(Object.values(loosingMovement));
          let keys = Object.keys(talentMovement).concat(Object.keys(loosingMovement))
          const payload = keys.map(x=>{
            if(x){
              return {name: x}
            }
          }).filter(Boolean);

          payload.length &&
          this.personSearchService.getCompanyLogoV2(payload).subscribe((logoResult: any) => {
            if (logoResult && logoResult.status == "success") {
              const resultName = logoResult.data
              resultName.forEach(obj => {
                const matchingObj = values.find((item) => item.company === obj.key);
                if (matchingObj) {
                  let companyLogo = obj.companylogo
                  matchingObj.companylogo = companyLogo;
                  matchingObj.website = obj.website ? obj.website : null;
                }

              });

              this.winningLosingTalent = values;
              const winningtolosingtalents = this.winningLosingTalent.filter(x => x.type == 'winningtoloosing');

              this.winningLosingTalentDataSource = new MatTableDataSource(winningtolosingtalents);
              this.gettalentmovementai(winningtolosingtalents)
              this.manualSort();
              if(this.winningCompanyTrends.length || this.loosingCompanyTrends.length) {
              this.getTalentMovementGraph();
              }
              // let newDataa:any  = this.completeDataFor12Months(Object.values(hireDepartureTalentMovement).sort((a, b) => a.order - b.order).slice(-12));
              // this.hireDepartureTalent = newDataa;
              // this.prepareHireDepartureTalentChartData();
            } else {
              this.winningLosingTalentDataSource = [];
              this.hireDepartureTalentDataSource = {};
            }
            // set hires and departures graph data available here
            this.dataAvailable.hiresAndDepartures = true;
            this.dataAvailable.winningLosingTalent = true;
          })
          return resolve(null);
        })
      })
    })

  }

  completeDataFor12Months(chartData: any){
    let currentDate:any = moment(chartData[0].date);
    const newData = [];
    for (let i = 0; i < 12; i++) {
      const formattedDate = moment(currentDate).format("YYYY-MM-DD");
      const existingData = chartData.find(data => data.date === formattedDate);
      if (existingData) {
          newData.push(existingData);
      } else {
          newData.push({
              company: chartData[0].company,
              departureTalent: 0,
              hireTalent: 0,
              totalTalent: 0,
              date: formattedDate,
              label: moment(currentDate).format('MMM yy'),
              order: parseInt(currentDate.toISOString().slice(0, 7).replace(/-/g, ""))
          });
      }
      currentDate = moment(currentDate).add(1, 'months');
  }
      return newData;
  }

  /**
 * Function set the start and end of aggreggate data according to page number
 * @param index page number in pagination
 */
  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;

      this.manualSort();


  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  async shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'talentmovement') return;

    // call latest data with company-logos
    await this.getcompanywinninglosingtalent();

    // trend chart config
    const trendChart = { renderAt: 'trendChart', dataSource: { ...this.hireDepartureTalentDataSource } };
    trendChart['height'] = '450';
    trendChart['width'] = '100%';
    trendChart['type'] = 'stackedcolumn2dline';
    delete trendChart?.['dataSource']?.['width'];
    delete trendChart?.['dataSource']?.['chart']?.['width'];
    delete trendChart?.['dataSource']?.['height'];
    delete trendChart?.['dataSource']?.['chart']?.['height'];

    this.tableHeaderName  = [this.tableHeaderObj['company'], this.tableHeaderObj['winning'], this.tableHeaderObj['losing']];

    const payloadForInsightsExport: ExportPayload = {
      tab: 'talentmovement',
      companydetails: this.companyDetails,
      chartdetails: [trendChart],
      winningLosingTalent: this.winningLosingTalent?.splice(0, 50),
      tableHeader: this.tableHeaderName
    }
    this.companyinsightsservice.sendInsightsExportData(payloadForInsightsExport);
  }

   /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
   handelRedirection(type: string, key: string) {
    const redirectFilters: Partial<FilterParams> = {
                        // Company context — always present
                        companyid: this.companyDetails?.id,
                        companyname: this.currentCompanyName,
                        alternativecompanynames: this.alternatecompanyNames,

                        // Read-only snapshot of the overview tab's OWN filter panel (person-search-filter
                        // sidebar). Nested so it can never collide with the listing page's normal filters.
                        insightsFilterData: this.filterData,
                      };
        switch (type) {
            case 'winningtalent': {
        redirectFilters['winningtalent'] = [key];
        redirectFilters['recentcompanyhires'] = true;
        break;
      }
      case 'losingtalent': {
        redirectFilters['losingtalent'] = [key];
        redirectFilters['recentcompanyattrition'] = true;
        break;
      }
      case 'jobtitle': redirectFilters['mandatoryjobtitles'] = [key]; break;
        }

           const uniqueKey = this.hashService.generateUniqueHash();
              localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

              const url = `/candidate-list?type=search&redirectSource=company-insights&key=${uniqueKey}`;
              window.open(url, '_blank');

  }

  gettalentmovementai(data) {
    let talentmovementdata: any;
    talentmovementdata = data.map(x=>{
    let res: any ={};
    res['Company'] = x.company;
    res['Winning'] = x.winningTalent;
    res['Loosing'] = x.losingTalent;

    return res;
  })
  this.talentmovementAI = {
    talentmovement: talentmovementdata
  }
  if(talentmovementdata.length == 0)
    this.talentmovementAI = null;
  }

  private setLoaders() {
    this.dataAvailable.hiresAndDepartures = false;
    this.dataAvailable.winningLosingTalent = false;
  }

  getCompanyInfo(companyname){
    let companyData = [];

    if(companyname){
      companyData.push({
        name: companyname
      });
    }

    companyData?.length &&
    this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.data){
        let companyDetails = res.data[0]
        this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
        this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
        this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
        this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
        this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
        this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
        this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
        this.primaryCompanyInformation['id'] = companyDetails.id
        this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
        this.primaryCompanyInformation['key_id'] = companyDetails.id
        this.primaryCompanyInformation['twitter_url'] = companyDetails.twitter_url ? companyDetails.twitter_url : null;
        this.primaryCompanyInformation['github_url'] = companyDetails.github_url ? companyDetails.github_url : null;
        this.primaryCompanyInformation['facebook_url'] = companyDetails.facebook_url ? companyDetails.facebook_url : null;

      }
    });
  }

getTalentMovementGraph() {
  const today = new Date();
  const months: string[] = [];
 const end = new Date(); // today
  end.setMonth(end.getMonth() - 1); // move to last month
  for (let i = 11; i >= 0; i--) {
  const d = new Date(end.getFullYear(), end.getMonth() - i, 1); // Day set to 1
  const date = moment(d).format('YYYY-MM-DD');
  const iso = d.toISOString().split('T')[0]; // Ensures format: YYYY-MM-01
  months.push(date);
  }

  const winningMap = new Map(this.winningCompanyTrends.map(item => [item.key_as_string, item.doc_count]));
  const loosingMap = new Map(this.loosingCompanyTrends.map(item => [item.key_as_string, item.doc_count]));

  // Step 3: Combine into final array with all 12 months
  const mergedArray = months.map(month => ({
    key_as_string: moment(month).format('MMM yy'),
    winning: winningMap.get(month) ?? 0,
    loosing: loosingMap.get(month) ?? 0
  }));
  this.talentmovementGraphData = mergedArray;
  console.log(this.talentmovementGraphData);
  this.prepareHireDepartureTalentChartData();
}

  private prepareHireDepartureTalentChartData(): void {
    this.hireDepartureTalentDataSource = {
      chart: {
        theme: 'fusion',
        drawcustomlegendicon: '1',
        showYAxisLine: 0,
        showYAxisValues: 1,
        plottooltext: '$label, $seriesname: $dataValue',
        palettecolors: '#FFA8A8,#95E1D3',
        labelFont: "Poppins",
        legendItemFont: "Poppins",
        showValues: '1',
        minPlotHeightForValue: "10",
        placeValuesInside: "0",
        plotHoverEffect: "1",
        legendItemFontSize: "12",
        baseFontSize: "12"
        },
      categories: [
        {
          category: this.talentmovementGraphData.map((item) => ({ label: item.key_as_string }))
        }
      ],
      dataset: [
            {

              seriesname: 'Losing',
              data: this.talentmovementGraphData.map((item) => ({ value: -item.loosing })),
            },
            {
              seriesname: 'Winning',
              data: this.talentmovementGraphData.map((item) => ({ value: item.winning }))
            },
            {
              seriesname: "Growth Ratio",
              renderas: "line",
              dashed:'1',
              showvalues: "0",
              // anchorbgcolor: "#FDCB50",
              color: "#827b7a",
              data: this.talentmovementGraphData.map((item) => ({ value: item.winning - item.loosing }))
            }
      ],
    };
    console.log(this.hireDepartureTalentDataSource);
  }
}
